var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsIconDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-3165 -1546)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 22,
    height: 22,
    rx: 11,
    transform: "translate(3165 1546)",
    fill: "#226194"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_5307b2228894a5e5d9734196637a88ed",
    "data-name": "5307b2228894a5e5d9734196637a88ed",
    transform: "translate(3168.349 1547.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M14.4,6.1a.482.482,0,0,0-.448.448v4.394a1.349,1.349,0,0,1-1.345,1.345h-.942a.46.46,0,0,0-.448.448v.986L9.557,12.381a.637.637,0,0,0-.269-.09H2.7a.448.448,0,0,0,0,.9H9.153L11.4,15.026a.637.637,0,0,0,.269.09c.09,0,.135,0,.179-.045a.515.515,0,0,0,.269-.4v-1.48h.493a2.22,2.22,0,0,0,2.242-2.242V6.552A.482.482,0,0,0,14.4,6.1Zm-13,4.842v-5.6A1.349,1.349,0,0,1,2.742,4h9.864a1.365,1.365,0,0,1,1.345,1.255.428.428,0,0,0,.493.4.388.388,0,0,0,.4-.448,2.245,2.245,0,0,0-2.2-2.107H2.742A2.22,2.22,0,0,0,.5,5.342v5.6a2.275,2.275,0,0,0,.673,1.614.407.407,0,0,0,.314.135A.407.407,0,0,0,1.8,12.56a.433.433,0,0,0,0-.628A1.391,1.391,0,0,1,1.4,10.946Z",
    transform: "translate(-0.026 -0.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89_-_Outline",
    "data-name": "Path 89 - Outline",
    d: "M2.716,3.074A2.22,2.22,0,0,0,.474,5.316v5.6a2.275,2.275,0,0,0,.673,1.614.407.407,0,0,0,.314.135.407.407,0,0,0,.314-.135.433.433,0,0,0,0-.628,1.391,1.391,0,0,1-.4-.986v-5.6A1.349,1.349,0,0,1,2.716,3.971H12.58a1.365,1.365,0,0,1,1.345,1.255.428.428,0,0,0,.493.4.388.388,0,0,0,.4-.448,2.245,2.245,0,0,0-2.2-2.107H2.716m11.657,3a.482.482,0,0,0-.448.448V10.92a1.349,1.349,0,0,1-1.345,1.345h-.942a.46.46,0,0,0-.448.448V13.7L9.531,12.355a.637.637,0,0,0-.269-.09H2.671a.448.448,0,1,0,0,.9H9.127L11.369,15a.637.637,0,0,0,.269.09c.09,0,.135,0,.179-.045a.515.515,0,0,0,.269-.4v-1.48h.493a2.22,2.22,0,0,0,2.242-2.242V6.526a.482.482,0,0,0-.448-.448M2.716,3h9.909A2.326,2.326,0,0,1,14.9,5.171a.435.435,0,0,1-.093.357.491.491,0,0,1-.377.175.5.5,0,0,1-.075.006.5.5,0,0,1-.5-.481A1.292,1.292,0,0,0,12.58,4.045H2.716A1.272,1.272,0,0,0,1.445,5.316v5.6a1.31,1.31,0,0,0,.382.934.507.507,0,0,1,0,.732.479.479,0,0,1-.366.156.479.479,0,0,1-.366-.156A2.343,2.343,0,0,1,.4,10.92v-5.6A2.291,2.291,0,0,1,2.716,3ZM14.373,6a.558.558,0,0,1,.522.522V10.92a2.291,2.291,0,0,1-2.316,2.316h-.419v1.406a.573.573,0,0,1-.3.461.288.288,0,0,1-.226.061.694.694,0,0,1-.3-.1l-.014-.009L9.1,13.236H2.671a.522.522,0,1,1,0-1.045H9.262a.693.693,0,0,1,.3.1l.014.009,1.538,1.247v-.831a.534.534,0,0,1,.522-.522h.942a1.272,1.272,0,0,0,1.271-1.271V6.526A.558.558,0,0,1,14.373,6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M7.9,12.862a.762.762,0,1,0,.762-.762A.73.73,0,0,0,7.9,12.862Zm3.094,0a.762.762,0,1,0,.762-.762A.756.756,0,0,0,10.994,12.862Zm3.094,0a.762.762,0,1,0,.762-.762A.756.756,0,0,0,14.087,12.862Z",
    transform: "translate(-4.108 -4.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90_-_Outline",
    "data-name": "Path 90 - Outline",
    d: "M14.824,13.6a.762.762,0,1,0,0-1.524.756.756,0,0,0-.762.762.786.786,0,0,0,.762.762m-3.094,0a.762.762,0,1,0,0-1.524.756.756,0,0,0-.762.762.786.786,0,0,0,.762.762m-3.094,0a.762.762,0,1,0,0-1.524.73.73,0,0,0-.762.762.786.786,0,0,0,.762.762m6.187.074a.858.858,0,0,1-.836-.836A.827.827,0,0,1,14.824,12a.836.836,0,1,1,0,1.673Zm-3.094,0a.858.858,0,0,1-.836-.836A.827.827,0,0,1,11.73,12a.836.836,0,1,1,0,1.673Zm-3.094,0a.858.858,0,0,1-.836-.836A.8.8,0,0,1,8.636,12a.836.836,0,1,1,0,1.673Z",
    transform: "translate(-4.082 -4.965)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsIconDark);
export default __webpack_public_path__ + "static/media/comments-icon-dark.d38745f556ec0fc69b6829dfe45e732a.svg";
export { ForwardRef as ReactComponent };